import React, {useContext} from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";

const IngredientsCurrency = ({responseIndex}) => {

    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById] = byId

    return(
        <React.Fragment>
            {
                <p>{
                    recipeById.billOfMaterials[responseIndex].hasOwnProperty('stock') ?
                        recipeById.billOfMaterials[responseIndex].stock.currency : <span>-</span>
                }</p>
            }
        </React.Fragment>
    )

}
export default IngredientsCurrency